const EventsTableComponent = {
    selector: 'sbEventsTable',
    template: require('./events-table.html'),
    bindings: {
        events: '<',
    },
};

export default EventsTableComponent;



// WEBPACK FOOTER //
// ./src/app/reports/events-table/index.js